module.exports = "/static-assets/_next/static/images/Poloaroid-5-ac21800ef6c72d80c908214d540448a6.png";